import { BannerAnnouncement } from 'components/Shared/BannerAnnouncement';
import TextAnnouncement from 'components/Shared/TextAnnouncement';

import { IAnnouncement } from 'interfaces/announcements';
import React, { useEffect, useState } from 'react';
import { filter } from 'rxjs/operators';
import { announcementService } from 'services/announcementService';

export const Announcements: React.FC = () => {
  const [announcement, setAnnouncement] = useState<IAnnouncement | null>(null);

  useEffect(() => {
    announcementService
      .getAnnouncement()
      .pipe(filter(announcement => !!announcement))
      .subscribe(announcement => setAnnouncement(announcement));
  });

  if (!announcement?.banner && !announcement?.alert) {
    return null;
  }

  if (announcement?.banner) {
    return <BannerAnnouncement {...announcement.banner} />;
  }

  return <TextAnnouncement {...announcement.alert} id={announcement.id} />;
};
